import { inject, Component, Inject, TemplateRef, ViewChild, Input, OnChanges, SimpleChanges, AfterViewInit, QueryList, signal, computed } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DataGridView, DataGridViewCollumn } from "../../../Componente/DataGridView";
import { PopUpView } from "../../../Componente/PopUpView";
import { Geraete } from "../../../Api/DcoApi/Admin/AdminClasses2";
import { FloatingButtonComponent } from "../../../Componente/floatingButton";
import { RestClient, User } from "../../../Api/DcoApi/Client/RestClient";
import { ToastService } from "../../../Akte/Services/Toasts/ToastService";
import { StatusModel } from "../../../Api/DcoApi/Status/StatusModel";
import { PGFilterService } from "../../Services/PGFilterService";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap/modal";
import { DateSelect } from "../../../Akte/Controlls/DateSelect";
import { VersandService } from "../../Services/VersandService";



@Component({
  imports: [
    CommonModule,
    FormsModule,
    DataGridView,
    DataGridViewCollumn,
    PopUpView, FloatingButtonComponent, DateSelect, FloatingButtonComponent
  ],
  selector: 'ASBExportDialog',
  templateUrl: './asbexport-dialog.html',
  standalone: true,
  styleUrl: './asbexport-dialog.css'
})
export class ASBExportDialog implements AfterViewInit {

  toastService: ToastService;

  private modalService = inject(NgbModal);
  modal = inject(NgbActiveModal);
  Entrys = signal<any[]>([])
  selected: number = 0;

  @Input() Abmelden:boolean = false;

  constructor(public pgService: PGFilterService) {
    this.toastService = inject(ToastService)

  }
  async ngAfterViewInit() {
    this.Entrys.set(await this.Client.Get<any>('/Export/ASBExport/GetExportablePartner?Abmeldung=' + this.Abmelden))

  }

  downloadFile(url:string, filename:string) {
    const link = document.createElement('a');
    link.href = url;
    // Setzt den Namen für die heruntergeladene Datei
    link.download = filename || '';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }


  addOrRemoveID(key: number) {
  this.selected = key;
  }

  async Export() {
    const today = new Date();

    const formattedDate = new Intl.DateTimeFormat('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).format(today);
    this.downloadFile(`/Export/${this.Abmelden ? "ASBAbmeldenExport" : "ASBExport"}?id=` + this.selected, this.Abmelden ? `Notfallplan_Abmelden_${formattedDate}.xlsx` : `Notfallplan_${formattedDate}.xlsx`);
    this.modal.dismiss();
  }





  Client: RestClient = new RestClient();




}







